<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
      <div class="container">
          <div class="row g-0">
              <div class="col-lg-6 col-md-6">
                  <ul class="breadcrumb">
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a href="events">Events</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a routerLink="/events" fragment="cultural">Cultural</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li>Farewell Function and Annual Prize Distribution</li>
                  </ul>
                  <div class="sec-title">
                      <h1><span>Farewell Function and Annual Prize Distribution 2025</span></h1>
                      <p>Bidding Adieu with Pride and Gratitude!
                          GHRCEM Pune celebrated its Farewell Function & Annual Prize Distribution 2025 with
                          heartfelt
                          memories, proud moments, and applause-worthy achievements. </p>
                  </div>
              </div>
          </div>
          <div class="breadcrumb-overlay overflow-hidden"
              style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-3.avif);">
          </div>
      </div>
  </section>
  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
        <ul  appLightgallery>
            <li class="grid-item1"
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-1.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-1.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-1.avif">
                </a>
            </li>
            <li class="grid-item2"
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-2.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-2.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-2.avif">
                </a>
            </li>
            <li class="grid-item3 "
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-3.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-3.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-3.avif">
                </a>
            </li>
            <!-- <li class="grid-item4 "
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-4.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-4.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-function&aanual-prize-4.avif">
                </a>
            </li> -->
        </ul>
      </div>
    </div>
  </section>
</main>
